<template>
  <div
    class="badge"
    v-if="!picturePath"
    :title="[
      first_name && last_name ? `${first_name} ${last_name}` : `${first_name}`,
    ]"
  >
    <p class="-ntb" style="user-select: none">
      {{ badgeUserName(first_name, last_name) }}
    </p>
  </div>
  <img
    v-else
    :src="picturePath"
    loading="lazy"
    :alt="`${first_name} ${last_name}`"
    class="badge"
    :title="[
      first_name && last_name ? `${first_name} ${last_name}` : `${first_name}`,
    ]"
  />
</template>

<script>
export default {
  props: ["picturePath", "first_name", "last_name"],
  data() {
    return {};
  },
  methods: {
    badgeUserName(first_name, last_name) {
      if (first_name && last_name)
        return `${first_name.charAt(0)}${last_name.charAt(0)}`;
      else if (first_name && !last_name) return `${first_name.charAt(0)}`;
      else return "--";
    },
  },
};
</script>

<style scoped>
.badge {
  width: 40px;
  min-width: 40px;
  height: 40px;
  min-height: 40px;
  border-radius: 50%;
  background: var(--focus3);
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--focus2) 0 0 0 1px;
}
img {
  object-fit: cover;
  object-position: center;
}
.badge .-ntb {
  color: var(--focus-text) !important;
}
</style>